import React, { Fragment } from 'react';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Icon,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { TitledCard } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { GenericFiltersContainer } from 'Components/filters/container';
import { ORDER_REPORT_FORM_NAME } from 'Common/FormEnum';
import { OrderFormReportEnum } from 'Common/FieldEnum';
import SelectSitesTable from 'Common/SelectSitesTable';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';

import { sortOptions } from './../helper/index';

const OrderFormReportComponent = props => {
  const {
    fields,
    handleChange,
    filterValues,
    clearFilters,
    sortOptionsValue,
    setSortByOption,
    setSelectedSites,
    activeIndexForFilter,
    handleClick,
    reactTableRef,
  } = props;

  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
              />
              <Grid.Row
                columns={2}
                style={{
                  marginTop: 16,
                }}
              >
                <Grid.Column width={13} verticalAlign={'bottom'}>
                  <TitledCard title={'Sort By'}>
                    <ReduxFormButtonGroup
                      options={sortOptions}
                      value={sortOptionsValue}
                      formName={ORDER_REPORT_FORM_NAME}
                      fieldName={OrderFormReportEnum.SortOptions}
                      type={'button'}
                      onChange={setSortByOption}
                    />
                  </TitledCard>
                </Grid.Column>
                <Grid.Column
                  width={3}
                  textAlign={'right'}
                  style={{ marginTop: '45px' }}
                  floated={'right'}
                >
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <TitledCard>
          <SelectSitesTable
            onChange={setSelectedSites}
            isActive={true}
            isLicensed={false}
            showPageSizeOptions={true}
            defaultPageSize={20}
            filterable={true}
            sortable={true}
            tableProps={{ ref: reactTableRef }}
          />
        </TitledCard>
      </Form>
    </Fragment>
  );
};

OrderFormReportComponent.propTypes = {
  fields: PropTypes.array.isRequired,
  activeIndexForFilter: PropTypes.number.isRequired,
  filterValues: PropTypes.object.isRequired,
  reactTableRef: PropTypes.object,
  setSortByOption: PropTypes.func,
  setSelectedSites: PropTypes.func,
  handleChange: PropTypes.func,
  clearFilters: PropTypes.func,
  handleClick: PropTypes.func,
  sortOptionsValue: PropTypes.number,
};

OrderFormReportComponent.defaultProps = {
  reactTableRef: null,
  sortOptionsValue: PrintSortTypeEnum.ItemCode,
  setSortByOption: () => {},
  setSelectedSites: () => {},
  handleChange: () => {},
  clearFilters: () => {},
  handleClick: () => {},
};
export default OrderFormReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/orderformreport/components/OrderFormReport.js